import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const MemberFilters = ({ 
  filters, 
  onFilterChange, 
  onReset,
  resultCount 
}) => {
  const membershipTypeOptions = [
    { value: 'all', label: '모든 회원권' },
    { value: 'regular', label: '일반 회원' },
    { value: 'trial', label: '체험 회원' }
  ];

  const skillLevelOptions = [
    { value: 'all', label: '모든 레벨' },
    { value: 'beginner', label: '초급 (1.0-2.5)' },
    { value: 'intermediate', label: '중급 (3.0-3.5)' },
    { value: 'advanced', label: '고급 (4.0-4.5)' },
    { value: 'expert', label: '전문가 (5.0+)' }
  ];

  const handleChange = (field, value) => {
    onFilterChange({ ...filters, [field]: value });
  };

  return (
    <div className="bg-card border border-border rounded-xl p-4 md:p-6 space-y-4">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-heading font-semibold text-foreground">필터</h3>
        <Button
          variant="ghost"
          size="sm"
          iconName="RotateCcw"
          iconPosition="left"
          onClick={onReset}
        >
          초기화
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <Input
          type="search"
          placeholder="이름 또는 전화번호 검색..."
          value={filters?.search}
          onChange={(e) => handleChange('search', e?.target?.value)}
        />

        <Select
          options={membershipTypeOptions}
          value={filters?.membershipType}
          onChange={(value) => handleChange('membershipType', value)}
          placeholder="회원권 유형"
        />

        <Select
          options={skillLevelOptions}
          value={filters?.skillLevel}
          onChange={(value) => handleChange('skillLevel', value)}
          placeholder="실력 레벨"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input
          type="date"
          label="등록일 시작"
          value={filters?.dateFrom}
          onChange={(e) => handleChange('dateFrom', e?.target?.value)}
        />

        <Input
          type="date"
          label="등록일 종료"
          value={filters?.dateTo}
          onChange={(e) => handleChange('dateTo', e?.target?.value)}
        />
      </div>
      <div className="pt-4 border-t border-border">
        <p className="text-sm caption text-muted-foreground">
          <span className="font-medium text-foreground data-text">{resultCount}</span>명의 회원이 검색되었습니다
        </p>
      </div>
    </div>
  );
};

export default MemberFilters;